import { useMutation, useQueryClient } from 'react-query';
import {
  cancelAutoTopUp,
  type CancelAutoTopUpResponse
} from '../../services/bettieAutoTopUpService';

export function useCancelAutoTopUp() {
  const queryClient = useQueryClient();
  return useMutation<CancelAutoTopUpResponse, Error, { bettieAutoTopUpId: string }>(
    ({ bettieAutoTopUpId }) => cancelAutoTopUp(bettieAutoTopUpId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['bettieAutoTopUp']);
      }
    }
  );
}
